import { Model } from '@/models/Model';
export class WorksheetModel extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'StudentDocument';
        this.$endpoint = '/subjects/generate-worksheet';
        this.$fillable = [];
    }
    generateWorksheet(payload) {
        this.$endpoint = 'subjects/generate-worksheet-prompts';
        return this.create(payload);
    }
}
export var WorksheetType;
(function (WorksheetType) {
    WorksheetType["DOCUMENT"] = "document";
    WorksheetType["APP"] = "app";
})(WorksheetType || (WorksheetType = {}));
export var AnswerVisibility;
(function (AnswerVisibility) {
    AnswerVisibility["HIDE"] = "hide";
    AnswerVisibility["SHOW"] = "show";
    AnswerVisibility["SHOW_WITH_SOLUTION"] = "show_with_solution";
})(AnswerVisibility || (AnswerVisibility = {}));
